import React from 'react';
import config from '../config';

const RHCAElectronic = () => {
  return (  
    <>
     <section className="page-header">
    <div className="page-header-bg" style={{backgroundImage: "url(assets/images/backgrounds/electronic1894-434.jpg)"}}>
    </div>
    <div className="container">
        <div className="page-header__inner">
            <h2>RHCA - Electronic City</h2>
            <ul className="thm-breadcrumb list-unstyled">
                <li><a href="/">Home</a></li>
                <li><span>/</span></li>
                <li>RHCA - Electronic City</li>
            </ul>
        </div>
    </div>
</section>

{/* Blog Details Start */}
<section className="blog-details">
    <div className="container">
        <div className="row justify-content-center">
            <div className="col-xl-8 col-lg-7">
                <div className="blog-details__left">
                    <div className="blog-details__img">
                        <img src="assets/images/blog/electronic770-427.jpg" alt="" />
                        
                    </div>
                    <div className="blog-details__content">
                       
                        <h3 className="blog-details__title">RHCA - Electronic City</h3>
                        <p className="blog-details__text-1">
                            We are thrilled to announce that Ray of Hope Centre for Autism will soon be opening a new branch in <b>Bangalore</b>! While the center is not yet operational, we are excited to bring the same child-centered, compassionate care and evidence-based programs that have made our Hosur branch a trusted hub for families.
                        </p>
                        <p className="blog-details__text-2">
                            This new center will provide individualized therapy, caregiver support, and a nurturing environment where children can learn, grow, and thrive. We can’t wait to welcome families and help even more children reach their full potential.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
  <section className="contact-details">
        <div className="container">
          <div className="contact-details__inner">
            <div className="contact-details__inner-content">
              <div className="contact-details__shape-1 float-bob-y">
                <img src={`${config.baseUrl}/assets/images/shapes/contact-details-shape-1.png`} alt=""/>
              </div>
              <ul className="list-unstyled contact-details__list">
                <li>
                  <div className="icon">
                    <span className="icon-help"></span>
                  </div>
                  <div className="content">
                    <p>Have Question?</p>
                    <h4><a href="tel:04344255800;ext=878">04344 - 255800, 878</a></h4>
                  </div>
                </li>
                <li>
                  <div className="icon">
                    <span className="icon-mailbox"></span>
                  </div>
                  <div className="content">
                    <p>Write Email</p>
                    <h4><a href="mailto:rayofhope@acaindia.org">rayofhope@acaindia.org</a></h4>
                  </div>
                </li>
                <li>
                  <div className="icon">
                    <span className="icon-maps-and-flags"></span>
                  </div>
                  <div className="content">
                    <p>Visit Center</p>
                    <h4>RR Towers, 134/106/43, Hosur Main Road, Hosa Road Intersection, Opposite Hosa Road Metro station, <br/>Chikkathoguru, Bengaluru, Karnataka – 560100</h4>
                  </div>
                </li>
                <li>
                  <div className="contact-details__social">
                    <a href="https://youtube.com/@rhca-india?si=Pu2jro4V4E-xB_l_" target='_blank'  rel="noopener noreferrer"><i class="fab fa-youtube"></i></a>
                                <a href="https://www.facebook.com/rayofhopeACA?mibextid=rS40aB7S9Ucbxw6v" target='_blank'  rel="noopener noreferrer"><i class="fab fa-facebook"></i></a>
                                <a href="https://www.linkedin.com/company/ray-of-hope-center-for-autism/" target='_blank'  rel="noopener noreferrer"><i class="fab fa-linkedin"></i></a>
                                <a href="https://www.instagram.com/rhcahosur?igsh=dmV5ZHA2czhsNWlv" target='_blank'  rel="noopener noreferrer"><i class="fab fa-instagram"></i></a>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
        <section className="google-map-two">
        <iframe
          title="Google Maps Location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4564.419517784099!2d77.85394981123915!3d12.801320918535346!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae75a06b6b2723%3A0xb5a227888b778e75!2sRay%20of%20Hope%20Center%20for%20Autism!5e1!3m2!1sen!2sin!4v1753941805524!5m2!1sen!2sin"
          className="google-map__two" 
          allowFullScreen
        ></iframe>
      </section>
    </>
  );
};

export default RHCAElectronic;